import { useCallback, useEffect, useLayoutEffect, useRef, useState, } from 'react';
import { format, getMonth, getYear } from 'date-fns';
import * as locales from 'date-fns/locale';
import { createMonthMatrix } from '../utils/datePicker';
export var formatCurrentMonth = function (date, locale) {
    return format(date, "MMMM yyyy", {
        locale: locales[locale],
    });
};
export var useMonthMatrix = function (_a) {
    var initialYear = _a.initialYear, initialMonth = _a.initialMonth, locale = _a.locale;
    var _b = useState(function () {
        return {
            year: initialYear || getYear(new Date()),
            month: initialMonth || getMonth(new Date()),
        };
    }), matrixData = _b[0], setMatrixData = _b[1];
    var _c = useState(formatCurrentMonth(new Date(), locale)), currentMonth = _c[0], setCurrentMonth = _c[1];
    var _d = useState(createMonthMatrix({ year: matrixData.year, month: matrixData.month })), matrix = _d[0], setMatrix = _d[1];
    var firstUpdate = useRef(true);
    var handleSetMatrix = useCallback(function (yearParam, monthParam) {
        setMatrixData(function (prevState) { return ({
            year: yearParam || prevState.year,
            month: monthParam || prevState.month,
        }); });
    }, []);
    var nextMonth = useCallback(function () {
        setMatrixData(function (prevState) { return ({
            year: prevState.month === 11 ? prevState.year + 1 : prevState.year,
            month: (prevState.month === 11 ? 0 : prevState.month + 1),
        }); });
    }, []);
    var prevMonth = useCallback(function () {
        setMatrixData(function (prevState) { return ({
            year: prevState.month === 0 ? prevState.year - 1 : prevState.year,
            month: (prevState.month === 0 ? 11 : prevState.month - 1),
        }); });
    }, []);
    var changeYear = useCallback(function (year) {
        return setMatrixData(function (prevState) { return ({
            year: year,
            month: prevState.month,
        }); });
    }, []);
    useEffect(function () {
        if (matrixData.year) {
            setCurrentMonth(formatCurrentMonth(new Date(matrixData.year, matrixData.month, 1), locale));
        }
    }, [matrixData]);
    useLayoutEffect(function () {
        if (firstUpdate.current) {
            firstUpdate.current = false;
            return;
        }
        setMatrix(createMonthMatrix({ year: matrixData.year, month: matrixData.month }));
    }, [matrixData]);
    return {
        monthMatrix: matrix,
        month: currentMonth,
        setMatrix: handleSetMatrix,
        nextMonth: nextMonth,
        prevMonth: prevMonth,
        changeYear: changeYear,
    };
};
